// NOTE: Dependencies: jQuery

(function ($) {
	$.fn.lmModal = function(options) {
		// check is dom element is defined 
		if (!this.length) {
			return false;
		}

		var	methods = {}

		// Default settings are set here.
		var settings = $.extend({
			$modalLaunchClass : $('.launch-modal'),
			$footer : $('#footer'),
			$document: $(document),
			$modalId: $('#modal'),
			$body : $('body'),
			url : '/modal-table',
			$modal : null 
		}, options);

		var $mainElement = this;

		methods.modalAjaxCall = function(ajaxUrl) {
			var $modalContent = $('#modalContent');
			$modalContent.empty();
			$.ajax({
				url: ajaxUrl,
				dataType: 'HTML',
				error: function(jqXHR, textStatus, errorThrown) {
					 settings.$modal.fadeIn( 0, function() {
						$modalContent.html(errorThrown);
					});
				},
				success: function(data, textStatus, jqXHR) {
					 settings.$modal.fadeIn( 0, function() {
						 console.log('AJAX DATA: ' + data);
						$modalContent.html(data);
					});
				}
			});

		}

		methods.events = function() {
			 settings.$modal = $( `
				<div id="modal" class="modal">
					<div class="modal__wrapper">
						<div class="modal__container">
							<button id="modalClose" class="modal__close">
								<svg class="icon">
									<use xmlns:xlink="https://www.w3.org/1999/xlink" xlink:href="/themes/custom/nhra/assets/images/sprite.svg#close"></use>
								</svg>
							</button>
							<div id="modalContent" class="modal__content">
							</div>
						</div>
					</div>
				</div>
			`);

			settings.$modalLaunchClass.on('click',  function(event){
				if(settings.$body.hasClass('modal-active')){
					return;
				}
				var $this = $(this),
					$modal = $('#modal');
				event.preventDefault();
				settings.$body.addClass('modal-active');
				$mainElement.append( settings.$modal);
				var ajaxUrl = $this.attr('href');
				methods.modalAjaxCall(ajaxUrl);
			});
			
			$mainElement.on('click', '#modalClose', function(){
				 settings.$modal.remove();
				settings.$body.removeClass('modal-active');
			})

	
			$mainElement.on('click', function(event) {
				if (  settings.$modal.length ) {
					var target = $(event.target);
					var targetId = target.attr('id');

					if (targetId == 'modal' ) {
						settings.$modalId.empty();
						settings.$modal.remove();
						settings.$body.removeClass('modal-active');
					} 
				}
			});

			settings.$document.keydown(function(event) {
				if (event.keyCode == 27) {
					settings.$modal.remove();
					settings.$body.removeClass('modal-active');
				}
			});	
		}
	
		// Run once methods when jquery plugin is called.
		methods.events(this);

	};
}(jQuery));